import React from 'react';
import Text from '@lightspeed/cirrus-text';

const Preparing = ({ show }) => (
  <div style={{ display: show ? 'block' : 'none' }}>
    <img
      src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/ecom/launch1_sm.gif"
      width="400"
      height="322"
      alt="eCom provisioning preparing"
    />
    <Text body bold className="cr-text-center">
      Preparing your Retail account...
    </Text>
  </div>
);

export default Preparing;
